import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    input,
    Input,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { CpwTaskStateService } from '@cpw/domain';
import { DrawerService, SharedUiModule } from '@pf/shared-ui';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { SafeAny } from '@pf/shared-common';
import { CpwActionButtonComponent } from './cpw-action-button.component';

@Component({
    selector: 'cpw-task-item',
    imports: [SharedUiModule, NzSpinModule, CpwActionButtonComponent],
    templateUrl: './cpw-task-item.component.html',
    styleUrl: './cpw-task-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpwTaskItemComponent {
    private readonly taskService = inject(CpwTaskStateService);
    private readonly drawerService = inject(DrawerService);

    closeTaskText = input<string>('Pause session');
    showCloseTask = input<boolean>(true);
    /** When set, renders a second header link that emits pauseTask without a confirm step. */
    pauseTaskText = input<string | undefined>(undefined);
    loading = input<boolean>(false);
    loadingMessage = input<string>('Loading...');
    confirmCloseTitle = input<string | undefined>(undefined);
    confirmCloseConfirmLabel = input<string>('Yes, cancel');
    confirmCloseKeepLabel = input<string>('Keep working');
    @Input({ required: true }) taskTitle!: string;
    @Output() closeTask = new EventEmitter<void>();
    @Output() pauseTask = new EventEmitter<void>();

    @ViewChild('confirmCloseDrawer', { static: true })
    confirmCloseDrawer!: TemplateRef<SafeAny>;

    task$ = this.taskService.activeTask$;

    onCloseLinkClick() {
        const title = this.confirmCloseTitle();
        if (!title) {
            this.closeTask.emit();
            return;
        }
        let confirmed = false;
        this.drawerService.createTemplateDrawer({
            title,
            content: this.confirmCloseDrawer,
            isMobile: true,
            placement: 'bottom',
            data: {
                confirm: () => {
                    confirmed = true;
                },
            },
            onClose: () => {
                if (confirmed) {
                    this.closeTask.emit();
                }
            },
        });
    }

    closeTaskHandler() {
        this.closeTask.emit();
    }
}
